import { createSelector } from 'reselect';
import { RootState, CommonState, ConfirmationDialogState, TextConfirmationModalState } from '../model/state';

/**
 * Direct selector to the state
 */
const selectCommon = () => (state: RootState) => state.common;

/**
 * Other specific selectors
 */
const selectIsContentLoading = () => createSelector(
  selectCommon(),
  (common: CommonState) => common.isContentLoading
);

const selectIsSubmitting = () => createSelector(
  selectCommon(),
  (common: CommonState) => common.isSubmitting
);

const selectTextConfirmationModal = () => createSelector(
  selectCommon(),
  (common: CommonState) => common.textConfirmationModal
);

const selectRenameDeviceModal = () => createSelector(
  selectCommon(),
  (common: CommonState) => common.renameDeviceModal
);

const selectConfirmationDialog = () => createSelector(
  selectCommon(),
  (common: CommonState) => common.confirmationDialog
);

const selectIsOpenConfirmationDialog = () => createSelector(
  selectConfirmationDialog(),
  (confirmationDialog: ConfirmationDialogState) => confirmationDialog.isOpen
);

const selectConfirmationDialogMetadata = () => createSelector(
  selectConfirmationDialog(),
  (textConfirmationModal: TextConfirmationModalState) => textConfirmationModal.metadata
);

const selectIsOpenTextConfirmationModal = () => createSelector(
  selectTextConfirmationModal(),
  (textConfirmationModal: TextConfirmationModalState) => textConfirmationModal.isOpen
);

const selectTextConfirmationModalMetadata = () => createSelector(
  selectTextConfirmationModal(),
  (textConfirmationModal: TextConfirmationModalState) => textConfirmationModal.metadata
);

const selectIsOpenRenameDeviceModal = () => createSelector(
  selectRenameDeviceModal(),
  (textConfirmationModal: TextConfirmationModalState) => textConfirmationModal.isOpen
);

const selectRenameDeviceModalMetadata = () => createSelector(
  selectRenameDeviceModal(),
  (textConfirmationModal: TextConfirmationModalState) => textConfirmationModal.metadata
);

const selectCountryList = () => createSelector(
  selectCommon(),
  (common: CommonState) => common.countries
);

const selectRegionList = () => createSelector(
  selectCommon(),
  (common: CommonState) => common.regions
);

const selectTimezoneList = () => createSelector(
  selectCommon(),
  (common: CommonState) => common.timezones
);

const selectIsApiCacheDisabled = () => createSelector(
  selectCommon(),
  (common: CommonState) => common.apiCacheDisabled
);

export default selectCommon;
export {
  selectIsContentLoading,
  selectIsSubmitting,
  selectTextConfirmationModal,
  selectTextConfirmationModalMetadata,
  selectIsOpenTextConfirmationModal,
  selectRenameDeviceModal,
  selectIsOpenRenameDeviceModal,
  selectRenameDeviceModalMetadata,
  selectConfirmationDialog,
  selectIsOpenConfirmationDialog,
  selectConfirmationDialogMetadata,
  selectCountryList,
  selectRegionList,
  selectTimezoneList,
  selectIsApiCacheDisabled,
}
